<template>
  <v-list-tile @click="open">
    <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon></v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>渡航歴を追加する</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action class="text-xs-right">
      <v-btn flat :disabled="true"></v-btn>
    </v-list-tile-action>
    <v-dialog v-model="config.status.active" max-width="600" scrollable>
      <v-card>
        <v-card-title class="grey lighten-3 blue-grey--text text--darken-4">
          <span class="headline">渡航歴を追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md class="pa-0">
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs12 class="px-3">
                  <v-select
                    v-model="form.country"
                    label="渡航先の国"
                    item-text="label"
                    item-value="code"
                    :rules="rules.country"
                    :items="getNationItems"></v-select>
                </v-flex>
                <v-flex xs12 class="px-3">
                  <v-text-field
                    v-model="form.city"
                    label="都市"></v-text-field>
                </v-flex>
                <v-flex xs12 class="px-3">
                  <v-select
                    v-model="form.type"
                    label="渡航目的"
                    item-text="text"
                    item-value="value"
                    :rules="rules.type"
                    :items="getTypeItems"></v-select>
                </v-flex>
                <v-flex xs12 class="px-3">
                  <v-text-field required
                    v-model="printFormatedDepart"
                    :rules="rules.depart"
                    maxlength="30"
                    append-icon="event"
                    @click:append="datepick"
                    label="渡航日"></v-text-field>
                  <v-dialog v-model="config.datepicker.depart.status" max-width="290">
                    <v-date-picker
                      v-model="config.datepicker.depart.data"
                      color="amber"
                      locale="ja"
                      :day-format="date => new Date(date).getUTCDate()"
                      @input="datepicked"></v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs12 class="px-3">
                  <v-text-field
                    v-model="form.term"
                    label="期間"
                    maxlength="20"></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="grey lighten-3">
          <v-btn flat
            color="blue darken-2"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="blue darken-2" class="white--text"
            :disabled="!isValid"
            :loading="isLoading"
            @click="submit">追加する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile>
</template>

<script>
export default {
  name: 'insert-modal',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        },
        datepicker: {
          depart: {
            data: '',
            status: false
          }
        }
      },
      rules: {
        country: [
          v => !!v || '必須項目です'
        ],
        type: [
          v => !!v || '必須項目です'
        ],
        depart: [
          v => !!v || '必須項目です'
        ]
      },
      form: {
        valid: true,
        status: 'DONE',
        country: '',
        city: '',
        type: '',
        depart: '',
        term: '',
        note: ''
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        status: 'DONE',
        country: '',
        city: '',
        type: '',
        depart: '',
        term: '',
        note: ''
      })
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.axios.post(this.$url.api + 'user/about/insert/meta', {
          mtype: 'about.travel',
          form: this.form
        }, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            this.$emit('emit', {
              action: 'insert',
              data: {
                type: 'travels',
                resolve: res.data.data
              }
            })
          }
          this.$set(this.config.status, 'loading', false)
          this.$set(this.config.status, 'active', false)
        })
      }
    },
    datepick: function () {
      if (this.form.depart.split('-').filter(it => isFinite(it)).length === 3) {
        this.$set(this.config.datepicker.depart, 'data', this.form.depart)
      }
      this.$set(this.config.datepicker.depart, 'status', true)
    },
    datepicked: function () {
      this.$set(this.form, 'depart', this.config.datepicker.depart.data)
      this.$set(this.config.datepicker.depart, 'status', false)
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    printFormatedDepart: {
      get: function () {
        if (this.form && this.form.depart) {
          return (
            this.form.depart.split('-').filter(it => isFinite(it)).length === 3
          ) ? this.$moment(this.form.depart).format('YYYY/MM/DD') : this.form.depart
        } else {
          return ''
        }
      },
      set: function (newValue) {
        this.$set(this.form, 'depart', newValue)
      }
    },
    getStatusItems () {
      return this.$meta.visa.status
    },
    getNationItems () {
      return Object.keys(this.$meta.nations).map(key => {
        return {
          code: key,
          label: this.$meta.nations[key]
        }
      }).concat([{
        code: '?',
        label: '該当する国がないので備考欄に入力する'
      }])
    },
    getTypeItems () {
      return Object.keys(this.$meta.visa.types).map(key => {
        return {
          value: key,
          text: this.$meta.visa.types[key]
        }
      })
    }
  }
}
</script>
